var map = {
	"./yuandian1.png": 97677,
	"./yuandian2.png": 6998,
	"./yuandian3.png": 85087,
	"./yuandian4.png": 26432,
	"./yuandian5.png": 81257,
	"./yuandian6.png": 16114,
	"./yuandian7.png": 65115,
	"./yuandian8.png": 85228,
	"./yuandian9.png": 68117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77431;